import '@ant-design/compatible/assets/index.css';
import { useQuery } from 'react-query';
import React, { useCallback, useEffect, useState } from 'react';

import {
  Col,
  Spin,
  Row,
  Typography,
  Divider,
  DatePicker,
  Input,
  Card,
} from 'antd';
import DF from 'DisplayFramework';
import { toCurrency } from 'utils/utils';
import FormInput from 'components/FormInput';

import Form, { FormInstance } from 'antd/lib/form';

import ThirdPartyInput from 'components/ThirdPartyInput';
import InputCurrency from 'components/InputCurrency';
import GetLabel from 'DisplayFramework/components/GetLabel';
import TaxSelect from 'components/TaxSelect';
import moment from 'moment';
import { getFinAssetsByID } from 'services/finassets';

const { Text } = Typography;

export type TabAssetSaleProps = {
  objectid: number;
  form?: FormInstance;
  setSuccessful: any;
};

const TabAssetSale = ({ objectid, form, setSuccessful }: TabAssetSaleProps) => {
  const [state] = useState({
    isLoading: false,
    isModSelected: false,
    targetdate: '',
    feesamount: 0,
    feesformula: '',
    totalNet: 0,
    totalTax: 0,
    totalGross: 0,
  });
  const { data: asset, isLoading } = useQuery(
    ['getFinAssetListByAnyRef', { assetid: objectid }],
    () =>
      getFinAssetsByID({ assetid: objectid }).then((res: any) => {
        if (res.data) {
          let lasset = res.data;
          form?.setFieldsValue({
            tpidbyuer: {
              tpid: lasset?.tpidsupplier,
              tpname: lasset.suppliername,
              tpreference: lasset.refsupplier,
            },
            assetdescription: lasset?.assetlabel,
            assetid: objectid,
            effectdate: moment(lasset.endate),
            residualvalue: lasset.assetrvamount,
            assetoutnetamount: lasset.assetrvamount,
          });
          return lasset;
        }
      })
  );

  useEffect(() => {
    setSuccessful(isLoading);
  }, [isLoading]);

  const calculateTotal = () => {
    let assettaxrate = form?.getFieldValue('assettaxrate') ?? 0;

    let assetnet = form?.getFieldValue('assetoutnetamount');

    let feestaxrate = form?.getFieldValue('feestaxrate') ?? 0;
    let feesnet = form?.getFieldValue('feesnetamount') ?? 0;

    let assettaxamount = (assettaxrate * assetnet) / 100;

    let feestaxamount = (feestaxrate * feesnet) / 100;
    let totalnet = assetnet + feesnet;
    let totaltax = feestaxamount + assettaxamount;
    let totalgross = totalnet + totaltax;

    form?.setFieldsValue({
      invoicenetamount: totalnet,
      invoicetaxamount: totaltax,
      invoicegrossamount: totalgross,
    });
  };

  const disableDaysBeforeToday = useCallback(
    (d) => {
      if (d == null) {
        return null;
      }

      return (
        moment(asset?.endate) != null &&
        d.isBefore(moment(asset?.endate)) &&
        !d.isSame(moment(asset?.endate), 'day')
      );
    },
    [asset?.endate]
  );

  return (
    <DF.Provider pagcode="tabassetsale">
      <Spin spinning={state.isLoading || isLoading}>
        <Form form={form} layout="vertical">
          <Row gutter={30}>
            <Col span={18}>
              <Row>
                <Col span={3}>
                  <GetLabel label="asset" />
                </Col>
                <Col span={8}>
                  <GetLabel label="label" />
                </Col>
                <Col span={4}>
                  <GetLabel label="ctreference" />
                </Col>
                <Col span={4}>
                  <GetLabel label="clientname" />
                </Col>
                <Col span={4}>
                  <GetLabel label="enddate" />
                </Col>
              </Row>
              <Row>
                <Col span={3}>{asset?.assetreference}</Col>
                <Col span={8}>{asset?.assetlabel}</Col>
                <Col span={4}>{asset?.ctreference}</Col>
                <Col span={4}>{asset?.clientname}</Col>
                <Col span={4}>{asset?.endate}</Col>
              </Row>

              <Divider orientation="left">Sale Detail</Divider>
              <Row gutter={20}>
                <FormInput
                  col
                  md={10}
                  name="assetdescription"
                  //rules={[{ required: true }]}
                >
                  <Input />
                </FormInput>

                <FormInput
                  col
                  md={7}
                  name="assetoutnetamount"
                  rules={[{ required: true }]}
                >
                  <InputCurrency
                    currcode={
                      asset?.currcode ?? localStorage.getItem('currcode') ?? ''
                    }
                    onChange={calculateTotal}
                  />
                </FormInput>

                <FormInput
                  col
                  md={7}
                  name="assetouttaxcode"
                  rules={[{ required: true }]}
                >
                  <TaxSelect
                    taxflow="INOUT"
                    onSelected={(e) => {
                      form?.setFieldsValue({ assettaxrate: e?.taxrate ?? 0 });
                      calculateTotal();
                    }}
                  />
                </FormInput>
              </Row>
              <Row gutter={20}>
                <FormInput col md={10} name="feesdescription">
                  <Input />
                </FormInput>

                <FormInput col md={7} name="feesnetamount">
                  <InputCurrency
                    currcode={
                      asset?.currcode ?? localStorage.getItem('currcode') ?? ''
                    }
                    onChange={calculateTotal}
                  />
                </FormInput>

                <FormInput col md={7} name="feestaxcode">
                  <TaxSelect
                    taxflow="INOUT"
                    onSelected={(e) => {
                      form?.setFieldsValue({ feestaxrate: e?.taxrate ?? 0 });
                      calculateTotal();
                    }}
                  />
                </FormInput>
              </Row>
            </Col>

            <Col span={6} style={{ fontWeight: 'bold' }}>
              <Card
                type="inner"
                title={<GetLabel label="fininfo" />}
                style={{ background: '#F6F3F2' }}
              >
                <Row gutter={[8, 8]}>
                  <Col>
                    <FormInput
                      col
                      xs={24}
                      name="assetnetamount"
                      style={{ fontWeight: 'bold', color: 'red' }}
                    >
                      <Text>
                        {toCurrency(asset?.assetnetamount, asset?.currcode)}
                      </Text>
                    </FormInput>
                  </Col>
                </Row>
                <Row>
                  <FormInput
                    col
                    xs={24}
                    name="residualvalue"
                    style={{ fontWeight: 'bold', color: 'black' }}
                  >
                    <InputCurrency
                      currcode={
                        asset?.currcode ??
                        localStorage.getItem('currcode') ??
                        ''
                      }
                    />
                  </FormInput>

                  <FormInput col xs={24} name="marketvalue">
                    <Text>
                      {toCurrency(asset?.irvamountout, asset?.currcode)}
                    </Text>
                  </FormInput>

                  <Form.Item style={{ display: 'none' }}>
                    <FormInput name="assetid">
                      <Input />
                    </FormInput>
                  </Form.Item>
                </Row>
              </Card>
            </Col>
          </Row>
          <Divider orientation="left"></Divider>
          <Row gutter={30}>
            <Col span={18}>
              <Row gutter={30}>
                <FormInput
                  col
                  xs={8}
                  name="effectdate"
                  rules={[{ required: true }]}
                >
                  <DatePicker disabledDate={disableDaysBeforeToday} />
                </FormInput>
                <FormInput col xs={10} name="tpidbyuer">
                  <ThirdPartyInput role="CLIENT" />
                </FormInput>
              </Row>
            </Col>
            <Col span={6} style={{ fontWeight: 'bold', color: 'red' }}>
              <Card
                title={<GetLabel label="invoiceInfo" />}
                type="inner"
                style={{ background: '#F6F3F2' }}
              >
                <FormInput col xs={24} name="invoicenetamount">
                  <InputCurrency
                    currcode={
                      asset?.currcode ?? localStorage.getItem('currcode') ?? ''
                    }
                  />
                </FormInput>
                <FormInput col xs={24} name="invoicetaxamount">
                  <InputCurrency
                    disabled
                    currcode={
                      asset?.currcode ?? localStorage.getItem('currcode') ?? ''
                    }
                  />
                </FormInput>
                <FormInput col xs={24} name="invoicegrossamount">
                  <InputCurrency
                    disabled
                    currcode={
                      asset?.currcode ?? localStorage.getItem('currcode') ?? ''
                    }
                  />
                </FormInput>
              </Card>
            </Col>
          </Row>
        </Form>
      </Spin>
    </DF.Provider>
  );
};
export default TabAssetSale;
